module.exports = __webpack_public_path__ + "img/NS_Black_cleaned.23a33cb9.svg";